import PlayVideoPage from './play-video.page'

export default PlayVideoPage
